//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@Shared/components/general/page-header";
import CampaignsLoader from "./campaigns-loader";
import CampaignsTable from "./campaigns-table";
import PlanSimpleButton from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-simple-button.vue";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingCampaignsContainer",
  title() {
    return this.$t("sidebar.sections.campaigns");
  },
  components: {
    PageHeader,
    CampaignsLoader,
    CampaignsTable,
    PlanSimpleButton
  },
  data() {
    return {
      loading: false,
      addCampaignLink: {
        name: "marketing-campaign-add",
        params: {
          withEmptyData: true
        }
      }
    };
  },
  computed: {
    accountPlanPage() {
      return ACCOUNT_PLAN_PAGE.MARKETING_CAMPAIGN;
    }
  },
  mounted() {
    Amplitude.logEvent("Campaigns - visited");
  },
  methods: {
    goToAddCampaign() {
      this.$router.push(this.addCampaignLink);
    }
  }
});